export default {
  "numberLabel": "_numberLabel_1qz54_1",
  "badge": "_badge_1qz54_5",
  "xsmall": "_xsmall_1qz54_25",
  "small": "_small_1qz54_26",
  "medium": "_medium_1qz54_27",
  "thin": "_thin_1qz54_47",
  "fixedSize": "_fixedSize_1qz54_72",
  "primary": "_primary_1qz54_94",
  "secondary": "_secondary_1qz54_99",
  "info": "_info_1qz54_105",
  "danger": "_danger_1qz54_111",
  "warning": "_warning_1qz54_117",
  "merge": "_merge_1qz54_123",
  "ultimate": "_ultimate_1qz54_129",
  "upgrade": "_upgrade_1qz54_138",
  "done": "_done_1qz54_144",
  "alpha": "_alpha_1qz54_150",
  "beta": "_beta_1qz54_156",
  "inverted": "_inverted_1qz54_162"
};import "ni:sha-256;SoOobJl6xlq_2V-782smIVEt-PC3L8Uvd1gt0u7cf44";